import { getAdjustedISOString } from "pages/ControlCenter/ContentManagement/contentManagementUtils/contentManagementUtils";
import { filtersType } from "./types";

export const getFormattedFilters = (filtersForFormatted: filtersType) => {
  const formatted = Object.keys(filtersForFormatted).reduce((obj, key) => {
    const value = filtersForFormatted[key];
    const formatedObject = obj;
    if (value !== null) {
      if (key === "reportUpdateDatesRange") {
        formatedObject[key] = {
          startDate: value.startDate
            ? getAdjustedISOString(value.startDate)
            : "",
          endDate: value.endDate ? getAdjustedISOString(value.endDate) : "",
        };
      } else {
        formatedObject[key] = value;
      }
    }

    return formatedObject;
  }, {});
  return Object.keys(formatted).length === 0 ? null : formatted;
};
